import { ReactElement } from 'react';
import { SingleValueChart } from './single-value-chart';
import { useAnalyticsTranslation } from '../hooks';
import { useTasksAndAlertsAnalytics } from '../providers/tasks-and-alerts-analytics-provider';

export function TotalRealAlertsChart(): ReactElement {
    const { t } = useAnalyticsTranslation();
    const { totalRealAlertsData, status } = useTasksAndAlertsAnalytics();

    return (
        <SingleValueChart
            title={t('components.total_real_alerts_chart.title')}
            description={t('components.total_real_alerts_chart.description')}
            value={totalRealAlertsData?.value}
            dateString={totalRealAlertsData?.dateString}
            loading={status === 'pending'}
            error={status === 'error'}
        />
    );
}
